<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isLastLevel: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    const { icon, title, isLastLevel } = context.props
    const vnodes = []
    if (isLastLevel) {
      vnodes.push(<i class={['round']} />)
    } else if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon mr-8']} />)
      } else if(icon.includes('iconfont')) {
        vnodes.push(<i class={[icon, 'sub-el-icon mr-5 text-18']} />)
      } else {
        vnodes.push(<svg-icon icon-class={icon}/>)
      }
    }

    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  width: 24px;
  display: inline-block;
  text-align: center;
  color: currentColor;
  line-height: 36px;
}

.round {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #7E828B;
  margin-right: 14px;
  margin-left: -12px;
}
.mr-8 {margin-right: 8px;}
.mr-5 {margin-right: 5px;}
.text-18 { font-size: 18px }
</style>
